import { Button, Tooltip } from '@customerio/pluma-components/react';
import { useOpenSendEventModal } from '@/features/send-event';
import { useCanSendTestEvent } from '@/services/permissions';

/**
 * Send one event without leaving the events browser, so a workspace that has
 * just set an event up can see it arrive.
 *
 * Nothing is known about the send yet: the modal asks who it is for and what
 * it is called.
 */

/** Where the modal was opened from, as analytics names it. */
const SOURCE = 'Data Index Event List';

type SendEventButtonProps = {
  workspaceId: number;
};

export function SendEventButton({ workspaceId }: SendEventButtonProps) {
  const canSend = useCanSendTestEvent();
  const openSendEvent = useOpenSendEventModal();

  return (
    <Tooltip isDisabled={canSend} content="Contact an Admin to access this feature." isCustom={true}>
      {(context) => (
        <Button
          ref={context.reference.setReference}
          {...context.reference.getReferenceProps()}
          variant="primary"
          isDisabled={!canSend}
          onClick={() => openSendEvent({ workspaceId, source: SOURCE })}
        >
          Send event
        </Button>
      )}
    </Tooltip>
  );
}
